/** Created by azhou on 2019/2/22.*/
<!--注册销售关联酒店页面-->
<template>
  <div>
    <div class="container mt-4" v-if="userLoginMessage.status==2">
      <div class="text">
        <span>请搜索并申请成为一家酒店销售</span>
        <!-- <p v-if="positionLists.total>0">您已申请关联<span class="text-green" @click="isShowUpload=true">{{ positionLists.total}}</span>个酒店</p> -->
      </div>
      <div v-if="!$route.path.includes('info-manage') || userLoginMessage.type == 99" class="search mb-3">
          <div class="search-wrap">
            <el-autocomplete
              class="inline-input"
              v-model="BasicInfo.title"
              :fetch-suggestions="querySearchAsync"
              placeholder="搜索酒店品牌或名称..."
              :trigger-on-focus="false"
              @select="handleSelect"
              prefix-icon="el-icon-search"
            >
            <template slot-scope="{ item }">
              <!-- v-html 必须用，渲染包裹的span标签 -->
              <span v-html="$verify.highlightKeyword(item.title, BasicInfo.title)"></span>
            </template>
            </el-autocomplete>
            <el-button type="primary" class="bottom" icon="el-icon-search" @click="onTextareaBlur()">立即搜索</el-button>
          </div>
        <!-- <left-text-border class=" w-80"
            leftText="酒店名称"
            placeholder="请输酒店名称"
            required
            inputId="inputTitle"
            v-model="BasicInfo.title"/>
            <el-button @click="onTextareaBlur()" class=" w-15   btn-login" size="small">搜索</el-button> -->
      </div>
      <div>
      <!--搜索企业的列表-->
      <div v-if="isShow&&list.length == 0">
          未找到相关酒店，请重新输入
      </div>
      <ul class="list" v-if="list.length > 0">
        <li class="list-header">
          <div>酒店名称</div>
          <div>操作</div>
        </li>
        <li v-for="item in list" :key="item.id">
          <div>{{item.title}}</div>
          <div class="rimary cursor-pointer" @click="applyAssociation(item)">申请加入</div>
        </li>
      </ul>
      <el-pagination layout="prev, pager, next" background class="mt-3"
        :page-size="4"
        v-if="list.length > 0"
        :total=Number(total) :current-page="Number(BasicInfo.page)"
        @current-change="v => {this.BasicInfo.page=v;this.getHotelList()}" />
      </div>
      <!-- <el-button @click="submitForm(1)" class="mt-4 w-25 btn-login" v-if="isShow" >{{storeInfo.storeId>0?'继续创建酒店':'创建酒店'}}</el-button> -->
      <!-- <el-button @click="submitForm(5)" class="mt-4 w-25 btn-login" v-if="storeInfo.verify==2">新增酒店正在审核中</el-button> -->
    </div>
    <TransitionPage v-if="userLoginMessage.status==3"></TransitionPage>
  </div>
</template>

<script>
  import { mapState,mapGetters,mapActions} from 'vuex'
  import { UploadImages } from '@/assets/utils/uploadFiles'
  import TransitionPage from './Components/TransitionPage.vue'
  export default {
    name: 'TRegBasic',
    components: {TransitionPage},
    computed: {
      ...mapState(['userLoginMessage','positionLists','newMessageInform']),
      ...mapGetters(['isGroup','userInfo',"storeInfo"]),
      //当用户为单门店且在注册步骤时才显示上传营业执照,集团用户添加门店时才显示
    },
    data () {
      return {
        total:'',
        list:[],
        BasicInfo:{
          title:'',
          page:1,
          type:3,
          num:4,
        },
        isShow:false,        //是否是已搜索的状态
        isShowUpload:false,  //是否点击了已申请关联的状态
      }
    },
    watch: {
      //认证通过进行页面跳转
      newMessageInform (newVal) {
        if (newVal && (newVal.type === 3 || newVal.type === 51)) {
            if (newVal.verify == '1') {      //认证通过
                //管理员和集团账号时重新拉取门店信息
                this._alert('审核已通过',() => {
                     this.$router.push('/userCenter')          //自动跳转到会员中心
                })
                // else this.$router.push('/userCenter')          //单门店身份自动跳转到会员中心
            } else {
              this.updateInfo();
              this._alert('很遗憾，您的审核未通过，如有疑问请联系客服',null,'error');
            }
        }
      },
    },
    created() {
      this.updateInfo();
    },
    methods: {
      ...mapActions(['POST_checkStoreTitle','POST_UnionApply','getUserPositionLists','updateInfo','POST_SearchDocHotel']),
      /*失去焦点-搜索酒店*/
      async onTextareaBlur(e){
        this.BasicInfo.page=1;
        this.isShow=true;
        if(this.BasicInfo.title.trim()){
          this.getHotelList();
        }   
      },
      /*获取 已有酒店列表列表*/
      async getHotelList () {
        let result = await this.POST_checkStoreTitle(this.BasicInfo);
        this.list = result.list;
        this.total = result.count;
      },
      /*申请关联酒店*/
      async applyAssociation (item) {
        this.POST_UnionApply({
          data: {
            store_id:item.id,
            store_type:3,  //酒店
          },
          successFun: () => {
            this._alert('申请成功，请耐心等待通过',() => {
              this.updateInfo();
              //  this.$router.push('/userCenter')          //自动跳转到会员中心
            })
            // this.$message.success('申请成功，请耐心等待通过');
          },
        });
      },
      /*保存门店基本信息*/
      async submitForm (id) {
        this.$emit('saveInfo',id);
      },
      //搜索框的建议列表
      async querySearchAsync(queryString, cb) {
        //内容不等于空字符串
        if (queryString.trim() === '') {
          cb([]);
          return;
        };
        let res= await this.POST_SearchDocHotel({data:{title: queryString}});
        this.timeout = setTimeout(() => {
          cb(res.list);
        }, 2000 * Math.random());
      },
      //点击搜索框的建议项-跳转详情
      handleSelect(item) {
        this.BasicInfo.title=item.title;
      },
    }
  }
</script>
<style scoped>
    table{
        border-collapse:collapse;
        border-spacing:0;
    }
  .text{
    text-align: left;
    color: #666;
    margin-bottom: 20px;
    display: flex;
    justify-content: space-between;
  }
  .container{
    width: 60%;
    margin: 0 auto;
  }
  .list{
    width: 100%;
    margin: 0 auto;
    border: 1px #dcdfe6 solid;
    border-bottom: none;
    border-radius:3px;
  }
  .list li{
    display: flex;
    justify-content: space-between;
    width: 100%;
    
  }

  .list li div{
    width: 71%;
    padding: 1.2% 2%;
    text-align: left;
    border-bottom: 1px #dcdfe6 solid;
  }
  .list li div:nth-child(2){
    width: 25%;
    text-align: center;
    border-left: 1px #dcdfe6 solid;

  }
  .list  .list-header div{
    text-align: center;
  }
  .rimary{
    color: var(--smtc-color-primary); 
  }
  .text-green{
    margin-left: 4px;
    margin-right: 4px;
    cursor: pointer;
  }
  .prompt{
    color: #999;
    margin-top: 10px;
    display: block;
    font-size: 13px;
  }
  .search{
    display: flex;
    justify-content: space-between;
  }
  
  .search-wrap{
    width: 100%;
    display: flex;
    justify-content: space-between;
  }
  .inline-input{
    width: 80%;
  }
</style>
